<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6.49951C10.8284 6.49951 11.5 5.82794 11.5 4.99951C11.5 4.17108 10.8284 3.49951 10 3.49951C9.17157 3.49951 8.5 4.17108 8.5 4.99951C8.5 5.82794 9.17157 6.49951 10 6.49951Z"
      fill="black"
    />
    <path
      d="M19.9 17.3995L17.5 12.3995C17.2 11.5995 16.5 10.9995 15.6 10.9995H13.3C14.2 8.59951 15 6.19951 15 4.99951C15 2.19951 12.8 -0.000488281 10 -0.000488281C7.2 -0.000488281 5 2.19951 5 4.99951C5 6.19951 5.8 8.59951 6.8 10.9995H4.4C3.5 10.9995 2.8 11.5995 2.5 12.3995L0.1 17.3995C-0.1 17.9995 0 18.5995 0.4 19.1995C0.8 19.6995 1.4 19.9995 2 19.9995H18C18.6 19.9995 19.2 19.6995 19.6 19.1995C20 18.5995 20.1 17.9995 19.9 17.3995ZM10 1.99951C11.7 1.99951 13 3.29951 13 4.99951C13 6.49951 10.6 12.5995 10 13.9995C9.4 12.5995 7 6.49951 7 4.99951C7 3.29951 8.3 1.99951 10 1.99951Z"
      fill="black"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconLocation',
};
</script>
